export function generateUniqueCallbackId() {
    while (true) {
        const name = `rnCallback_${Math.random().toString(32).substring(2)}`;
        if (typeof window[name] === 'undefined') {
            return name;
        }
    }
}
export function postReactNativeMessage(eventType, params = {}) {
    const callback = generateUniqueCallbackId();
    const payload = { ...params, eventType, callback };
    const res = new Promise((resolve) => {
        window[callback] = (ret) => {
            resolve(ret);
            delete window[callback];
        };
    });
    if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify(payload));
    }
    return res;
}
